var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTokenRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.072 8.043a6.246 6.246 0 00-6.144 0L12.762 20.362l16.055 8.898A12.716 12.716 0 0138 25.333c3.61 0 6.872 1.52 9.183 3.927l16.055-8.93L41.072 8.043zM31.667 38c0-3.483 2.85-6.333 6.333-6.333s6.333 2.85 6.333 6.333-2.85 6.333-6.333 6.333-6.333-2.85-6.333-6.333zM9.5 25.777l16.245 9.025c-.285 1.013-.412 2.09-.412 3.198a12.64 12.64 0 009.5 12.255v17.638L12.762 55.638C10.735 54.53 9.5 52.408 9.5 50.097v-24.32zm31.667 42.116V50.255A12.64 12.64 0 0050.667 38c0-1.108-.127-2.185-.412-3.198L66.5 25.777v24.32c0 2.311-1.235 4.433-3.262 5.541L41.167 67.893z",
    fill: "#4A4A4A"
  })));
}
export default __webpack_public_path__ + "static/media/TokenRounded.fd648ec6.svg";
export { SvgTokenRounded as ReactComponent };